import { useTranslation } from 'react-i18next';

import { TableHead, TableHeader, TableRow } from '@/common/components/ui/table';

export const PolicyCoverageTableHeader = () => {
  const { t } = useTranslation();

  return (
    <TableHeader>
      <TableRow>
        <TableHead className="rounded-tl-lg border-r border-warm-gray-200 w-[75cqw] whitespace-normal">
          {t('garantie.garanties')}
        </TableHead>
        <TableHead className="border-r border-warm-gray-200 min-w-[92px]">
          {t('garantie.formulaire')}
        </TableHead>
        <TableHead className="border-r border-warm-gray-200 min-w-[92px]">
          {t('garantie.rp')}
        </TableHead>
        <TableHead className="border-r border-warm-gray-200 min-w-[92px]">
          {t('garantie.franchise')}
        </TableHead>
        <TableHead className="border-r border-warm-gray-200 min-w-[92px]">
          {t('garantie.montantGarantie')}
        </TableHead>
        <TableHead className="rounded-tr-lg min-w-[92px]">
          {t('garantie.prime')}
        </TableHead>
      </TableRow>
    </TableHeader>
  );
};
